import dayjs from "dayjs"
import {CesuAccountType} from "../constants/cesuAccountType"

export const timePatternPointsSymbol = "HH:mm"
export const timePatternHSymbol = "HH[h]mm"
export const timePatternHSymbolDatePicker = "HH'h'mm"

/**
 * Convert minutes to cesu account type hour mod
 */
export const convertMinutesForPadAccountsToString = (minutes, cesuAccountType) => {
    if (cesuAccountType === CesuAccountType.MINUTE_PER_MONTH) {
        return Math.floor(minutes / 60) + "h" + String(Math.floor(minutes % 60)).padStart(2, "0")
    }
    if (cesuAccountType === CesuAccountType.HUNDREDTH_OF_HOUR_PER_MONTH) {
        // Magic fix !
        // If it stays minutes but less than 1 hundredth, its 1 hundredth
        // otherwise it would be rounded to 0
        if (minutes !== 0 && minutes < 0.6) {
            minutes = 0.6
        }
        return String((Math.floor((minutes / 60) * 100) / 100).toFixed(2)) + " heure(s)"
    }
}

/**
 * Convert minutes to two splitted fields for hundredth of hour type and classical hour usage type.
 * Exemple : minutes = 65 for hundredth of hour type, it correspond to 1.08 hours, so it will return {hours: 1, minutes : 8}
 * Exemple : minutes = 65 for classical hour usage, it correspond to 1h05, so it will return {hours: 1, minutes : 5}
 */
export const convertMinutesToHoursAndMinutesSplitted = (minutes, cesuAccountType) => {
    if (cesuAccountType === CesuAccountType.HUNDREDTH_OF_HOUR_PER_MONTH) {
        const splited = String((Math.floor((minutes / 60) * 100) / 100).toFixed(2)).split(".")
        return {
            hours: Number(splited[0]),
            minutes: Number(splited[1]),
        }
    } else {
        return {
            hours: Math.floor(minutes / 60),
            minutes: minutes % 60,
        }
    }
}

/**
 * Used to convert hundredth of hour or classical hour usage, splitted in two fields to minutes
 * Exemple : hours = 1 and minutes = 30 for Hundredth of hour type, it means to convert 1.3 hours to minutes
 * Exemple2 : hours = 1 and minutes = 30 for classical hour type, it means to convert 1h30 to minutes
 */
export const convertHoursAndMinutesFieldsToTotalMinutes = (hours, minutes, cesuAccountType) => {
    if (cesuAccountType === CesuAccountType.HUNDREDTH_OF_HOUR_PER_MONTH) {
        // Magic fix !
        // If it stays minutes but less than 1 hundredth, its 1 hundredth
        // otherwise it would be rounded to 0
        if (Number(minutes) !== 0 && Number(minutes) < 0.6) {
            minutes = 0.6
        }
        return (Number(hours) + Number(minutes) / 100) * 60
    } else {
        return Number(hours) * 60 + Number(minutes)
    }
}

/**
 * Used to convert an amount with an hourlyRate to a number of hours and minutes
 */
export const convertAmountAndHourlyRateToHoursAndMinutesSplitted = (amount, hourlyRate, cesuAccountType) => {
    const splitted = String((Math.floor((amount / hourlyRate) * 100) / 100).toFixed(2)).split(".")
    if (cesuAccountType === CesuAccountType.HUNDREDTH_OF_HOUR_PER_MONTH) {
        return {
            hours: Number(splitted[0]),
            minutes: Number(splitted[1]),
        }
    } else {
        return {
            hours: Number(splitted[0]),
            minutes: Math.floor((Number(splitted[1]) * 60) / 100),
        }
    }
}

/**
 * Calculate time between two dayjs objects and return string.
 * Exemple : first time is 5:00 AM and second time is 11:31AM, it will return "6h31"
 */
export const numberOfHoursBetweenTwoTimes = (firstTime, secondTime) => {
    const duration = dayjs.duration(firstTime.diff(secondTime))

    // Duration hours part
    const hours = Math.abs(parseInt(duration.asHours())).toString()

    // Duration minutes part
    const minutes = Math.abs(parseInt(duration.asMinutes()) % 60)
        .toString()
        .padStart(2, "0")

    return hours + "h" + minutes
}

/**
 * Convert minutes to hours into formatted string
 */
export const convertMinutesToHoursIntoFormattedString = (minutes, splitter) => {
    return Math.floor(minutes / 60) + splitter + String(Math.floor(minutes % 60)).padStart(2, "0")
}

/**
 * Convert string duration like "HH:mm" or "HHhmm" to minutes.
 * @param {*} duration : Exemple : 03:45
 * @returns If duration equals 03:45, it returns 225 minutes
 */
export const convertStringDurationToMinutes = duration => {
    let splitter = duration?.includes("h") ? "h" : ":"
    const splittedDuration = duration.split(splitter)

    let minutes = 0

    if (splittedDuration.length === 2) {
        minutes = Number(splittedDuration[0]) * 60 + Number(splittedDuration[1])
    } else {
        minutes = duration * 60
    }

    return minutes
}
